"use client";

import { useEffect } from "react";

const AdScript = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.setAttribute("data-cfasync", "false");
    script.setAttribute("data-clbaid", "");
    script.src = "//deductgreedyheadroom.com/bn.js";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div data-cl-spot="2038546"></div>;
};

export default AdScript;
